import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=1b1f362a&"
import script from "./BasicInfo.vue?vue&type=script&lang=js&"
export * from "./BasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=1b1f362a&prod&lang=css&"
import style1 from "./BasicInfo.vue?vue&type=style&index=1&id=1b1f362a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports